var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lzlinks-opencamera"},[_c('div',{staticClass:"lzlinks-opencamera-btn"},[_c('el-button',{staticStyle:{"position":"fixed","top":"20px","right":"120px","z-index":"100"},attrs:{"type":"success"},on:{"click":_vm.open}},[_vm._v(_vm._s(_vm.btnName))])],1),_c('div',{attrs:{"id":"myPlayer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }